import useFamilyUserSelectStore from "./useFamilyUserSelect"
import { useFamilyQuery } from "../../../networking/queries"

/**
 * A custom hook that retrieves the currently selected family member's profile.
 *
 * This hook combines data from the family query and the family user selection store
 * to find and return the profile of the currently selected family member.
 *
 * @returns {Object} An object containing:
 *   - selectedProfile: The profile object of the selected family member, or undefined if no member is selected
 *                     or if the selected member's profile cannot be found in the family data.
 *
 * @example
 * const { selectedProfile } = useSelectedFamilyMember(); FamilyChildProfile | FamilyParentProfile | undefined
 * const userId = selectedProfile?.user.id;
 * }
 */

const useSelectedFamilyMember = () => {
  const { data: family } = useFamilyQuery()
  const { selectedUserId } = useFamilyUserSelectStore()

  const selectedProfile = family?.profiles.find(
    (profile) => profile.user.id === selectedUserId
  )

  return { selectedProfile }
}

export default useSelectedFamilyMember
